export const Logo = ({ light }: { light?: boolean }) => {
  return (
    <svg
      viewBox="10 10 40 40"
      xmlns="http://www.w3.org/2000/svg"
      color="currentColor"
      className="w-[28px] md:w-[34px] h-[28px]  md:h-[34px]"
    >
      <rect
        className={`${light ? "fill-[#f7f2e9]" : "fill-black"}`}
        x="10"
        y="10"
      />

      <rect
        className={` ${
          light ? "stroke-black fill-[#f7f2e9]" : "stroke-[#f7f2e9] fill-black"
        } stroke-[4px]`}
        x="10"
        y="10"
        width={40}
        height={40}
      />

      <circle
        className={`${light ? "fill-black" : "fill-[#f7f2e9]"}`}
        cx="52"
        cy="52"
        r="41"
      />

      <rect
        className={`${light ? "fill-[#f7f2e9]" : "fill-black"}`}
        x="50"
        y="10"
      />
    </svg>
  );
};

export default Logo;
